"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetBackgroundColors = void 0;
var _mui = require("@ori-ui/mui");
var _models = require("../models");
/* istanbul ignore file @preserve -- constants */

const useGetBackgroundColors = () => {
  const theme = (0, _mui.useTheme)();
  return [{
    key: _models.QRBackgroundColor.Green,
    shadeColor: theme.palette.green[200],
    backgroundColor: theme.palette.green[200]
  }, {
    key: _models.QRBackgroundColor.Blue,
    shadeColor: theme.palette.blue[200],
    backgroundColor: theme.palette.blue[200]
  }, {
    key: _models.QRBackgroundColor.Purple,
    shadeColor: theme.palette.purple[200],
    backgroundColor: theme.palette.purple[200]
  }, {
    key: _models.QRBackgroundColor.Pink,
    shadeColor: theme.palette.pink[200],
    backgroundColor: theme.palette.pink[200]
  }, {
    key: _models.QRBackgroundColor.Brown,
    shadeColor: theme.palette.brown[200],
    backgroundColor: theme.palette.brown[200]
  }, {
    key: _models.QRBackgroundColor.White,
    shadeColor: theme.palette.grey[100],
    backgroundColor: theme.palette.common.white
  }];
};
exports.useGetBackgroundColors = useGetBackgroundColors;
